import axios from 'axios';
import { API_CONFIG } from '../../config/constants';

// Use centralized API configuration with /api path
const API = `${API_CONFIG.BASE_URL}/api`;

const api = axios.create({ 
  baseURL: API,
  headers: {
    'Content-Type': 'application/json; charset=utf-8',
    'Accept': 'application/json; charset=utf-8'
  }
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token && config.headers) config.headers.Authorization = `Bearer ${token}`;
  // Ensure UTF-8 encoding
  if (config.headers) {
    config.headers['Content-Type'] = 'application/json; charset=utf-8';
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.clear();
      window.location.href = '/';
    }
    return Promise.reject(err);
  }
);

export default api;
